﻿import { Tag, TagProps, Tooltip } from 'antd';
import { observer } from 'mobx-react';
import React, { CSSProperties, useEffect, useRef, useState } from 'react';

import ScaleLine, { Units } from 'ol/control/ScaleLine';
import Map from 'ol/Map';

export type ScaleLineUnits = "metric" | "nautical";

export interface Props extends Pick<TagProps, "color"> {
    map: Map | undefined,
    id?: string,
    className?: string,
    style?: CSSProperties,
    units?: ScaleLineUnits,
    unitsChanged?: (unit: ScaleLineUnits) => void,
    tooltip?: string,
    mobile?: boolean
}

const MapScaleLine: React.FC<Props> = ({
    map,
    id,
    className = "map-scale-line",
    style,
    units = "metric",
    unitsChanged = () => { },
    color = "default",
    tooltip = "Click to change units",
    mobile,
}) => {

    const borderStyle = '2px solid black';

    const element = useRef<HTMLDivElement>(null);    
    const [control, setControl] = useState<ScaleLine>();   
    const [unitsInternal, setUnitsInternal] = useState<ScaleLineUnits>(units);

    useEffect(() => {
        setUnitsInternal(units);
    }, [units]);

    useEffect(() => {
        if (map && element.current) {

            const control = new ScaleLine({
                className,
                target: element.current
            });

            map.addControl(control);
            setControl(control);

            return () => {
                try {
                    map.removeControl(control);
                }
                catch { }
            }
        }
    }, [map]);

    useEffect(() => {
        if (control) 
            control.setUnits(unitsInternal);
    }, [control, unitsInternal]);         

    const toggleUnits = () => {
        const value: Units = unitsInternal === "metric" ? "nautical" : "metric";
        setUnitsInternal(value);
        unitsChanged(value);
    };

    return (
        <Tooltip title={tooltip} placement='top'>
            <Tag id={id} className={className}
                ref={element} color={color} onClick={toggleUnits}            
                style={{
                    pointerEvents: 'auto',
                    position: 'absolute',
                    cursor: 'pointer',
                    textAlign: "center",
                    padding: 0,
                    borderRight: borderStyle,
                    borderLeft: borderStyle,
                    borderBottom: borderStyle,
                    marginBottom: -1,
                    ...style
                }}>          
            </Tag>
        </Tooltip>
    )
}

export default observer(MapScaleLine);